import * as React from 'react'

type ScaleBadgeProps = {
  label: string
  color: string
  faded?: boolean
}

export const ScaleBadge: React.FC<ScaleBadgeProps> = ({
  label,
  color,
  faded = false,
}) => {
  return (
    <span
      className={`text-[12px] inline-flex items-center gap-2 rounded-md border border-[#D9DDE7] bg-white px-3 py-1.5 font-normal leading-5 ${
        faded ? 'text-[#9AA3B8]' : 'text-[#1D264A]'
      }`}
    >
      <span
        className="h-2.5 w-2.5 rounded-full"
        style={{
          backgroundColor: color,
          opacity: faded ? 0.5 : 1,
        }}
      />
      {label}
    </span>
  )
}
